import React from 'react';

export default function VitalCard({ label, big, bigColor, chart, sub, onClick, ariaLabel, tooltip, actionHint, headerExtra }) {
  const interactive = typeof onClick === 'function';
  const baseStyle = { background: '#fff', borderColor: '#ECEBE5', position: 'relative' };
  const Tag = interactive ? 'button' : 'div';
  const tagProps = interactive
    ? {
        type: 'button',
        onClick,
        'aria-label': ariaLabel,
        title: tooltip,
        className: 'rounded-lg border p-4 text-left w-full',
        style: { ...baseStyle, cursor: 'pointer' }
      }
    : {
        title: tooltip,
        className: 'rounded-lg border p-4',
        style: baseStyle
      };
  return (
    <Tag {...tagProps}>
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-wider" style={{ color: '#9A9A95', letterSpacing: '0.06em' }}>{label}</div>
        <span className="inline-flex items-center gap-1.5">
          {interactive && (
            <span
              aria-hidden="true"
              className="inline-flex items-center justify-center rounded-full"
              style={{
                width: 18, height: 18,
                background: '#F2F1ED', color: '#3A3A38',
                fontSize: 14, lineHeight: 1, fontWeight: 600
              }}
            >+</span>
          )}
          {headerExtra}
        </span>
      </div>
      <div className={`mt-2 flex items-center gap-3 ${chart ? 'justify-between' : ''}`}>
        <div style={{ fontSize: 20, fontWeight: 600, color: bigColor || '#1A1A1A', fontVariantNumeric: 'tabular-nums' }}>{big}</div>
        {chart && <div>{chart}</div>}
      </div>
      {sub && <div className="mt-2 text-[11.5px]" style={{ color: '#6B6B68', lineHeight: 1.4 }}>{sub}</div>}
      {actionHint && interactive && (
        <div className="mt-2 text-[10.5px] uppercase tracking-wider" style={{ color: '#9A9A95', letterSpacing: '0.06em' }}>
          {actionHint}
        </div>
      )}
    </Tag>
  );
}
